export default __webpack_public_path__ + "static/media/png-marker-noir-local-removebg-preview.335259a4.png";